import React, { useEffect, useState } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import {
  OPContainer,
  OPBox,
  OPHeader,
  OPWrapper,
} from "../settings/SettingsStyled";
import ScrollContainer from "./ScrollHost";
import {
  // CardsContainer,
  TitleS,
  SubTitle,
  BetInfoBox,
  Button,
  Results,
  CardBox,
  Subtext,
  Text,
  Loader,
  // Scroll,
  // ScrollBar,
} from "./BetReplyStyled";

import {
  handleCardSymbol,
  handleCardSubText,
  handleCardSuit,
} from "../../helpers/getCards";
import {
  Card,
  CardSymbol,
  CardSuit,
} from "../detailedHistory/DetailedHistoryStyled";
import { Title } from "../provablyFair/ProvFairStyled";

export default ({
  handleAbove,
  handleAboveAnimation,
  aboveAnim,
  betReply,
  floorFigure,
  precision,
  handleNotification,
  roundID,
  audio,
}) => {
  const [btnAnimation, setBtnAnimation] = useState(false);
  const [initAnimation, setInitAnimation] = useState(true);
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [offset, setOffset] = useState(0);
  const { goBack, confirm } = audio;
  const getCurrentIndex = (i) => {
    return (
      betReply &&
      i + 1 < betReply.userActions.length &&
      betReply.userActions[i + 1]
    );
  };

  const copyToClipboard = (e) => {
    e.target.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };
  const handleAnimation = (e) => {
    setInitAnimation(e);
  };
  useEffect(() => {
    betReply &&
      betReply.round_id !== roundID &&
      handleNotification("Bet info is not found");
  }, [betReply, roundID, handleNotification]);
  return (
    <OPContainer aboveAnim={aboveAnim} className="prov">
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim} style={{ overflowX: "hidden" }}>
          <OPHeader aboveAnim={aboveAnim} close={btnAnimation === "close"}>
            <p>Bet Reply</p>
            <span
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => {
                setBtnAnimation("close");
                goBack();
                handleAboveAnimation(false);
                setTimeout(() => {
                  handleAbove(false);
                }, 100);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          {betReply && betReply.round_id === roundID ? (
            <>
              <TitleS>Bet ID</TitleS>
              <SubTitle>{betReply && betReply.bet_id}</SubTitle>
              <ScrollContainer
                handleAnimation={(e) => handleAnimation(e)}
                initAnimation={initAnimation}
                needScroll={betReply.userActions.length > 3}
                offset={offset}
              >
                {betReply.userActions.map(
                  (card, index) =>
                    card.cardName !== "" && (
                      <Results
                        className="card"
                        key={index}
                        childCount={index}
                        initAnimation={initAnimation}
                      >
                        <CardBox>
                          <Card
                            col={getCurrentIndex(index).action === "CHANGE"}
                          >
                            <CardSymbol
                              col={
                                card.cardName.charAt(0) === "S" ||
                                card.cardName.charAt(0) === "C"
                              }
                            >
                              {handleCardSymbol(card)}
                            </CardSymbol>
                            <CardSuit>{handleCardSuit(card)}</CardSuit>
                          </Card>
                          <Text childCount={index}>
                            {card.action === "NONE"
                              ? "START"
                              : floorFigure(card.coef, 2) + "x"}
                          </Text>
                        </CardBox>
                        <Subtext
                          childCount={index}
                          initAnimation={initAnimation}
                          onAnimationEnd={() => {
                            initAnimation &&
                              betReply.userActions.length > 3 &&
                              setOffset(index * 110);
                            if (index === betReply.userActions.length - 1) {
                              setInitAnimation(false);
                            }
                          }}
                          isSame={getCurrentIndex(index).action === "SAME"}
                          isWin={getCurrentIndex(index).coef > 0}
                        >
                          {handleCardSubText(index, betReply.userActions)}
                        </Subtext>
                      </Results>
                    )
                )}
              </ScrollContainer>
              <BetInfoBox>
                <TitleS>Bet</TitleS>
                <SubTitle>
                  {betReply.betAmount.toFixed(precision)} {betReply.currency}
                </SubTitle>
                <TitleS>Payout</TitleS>
                <SubTitle>
                  {betReply.winCoef > 0 ? betReply.winCoef : "0.00"} X
                </SubTitle>
                <TitleS>Win</TitleS>
                <SubTitle>
                  {betReply.winAmount > 0 ? betReply.winAmount : "0.00"}{" "}
                  {betReply.currency}
                </SubTitle>
              </BetInfoBox>
              <Title>
                <h4>Clients seed</h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={betReply.client_seed}
                  spellCheck="false"
                  readOnly="readOnly"
                />
              </Title>
              <Title>
                <h4>
                  {betReply.server_seed !== ""
                    ? "Server seed"
                    : "Server seed hash"}
                </h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={
                    betReply.server_seed !== ""
                      ? betReply.server_seed
                      : betReply.server_seed_SHA256
                  }
                  spellCheck="false"
                  readOnly="readOnly"
                />
              </Title>
              <Title>
                <h4>Nonce</h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={betReply.nonce}
                  spellCheck="false"
                  readOnly="readOnly"
                  className="nonce"
                />
              </Title>
            </>
          ) : (
            <Loader>
              <p className="loading">
                Loading
                <span />
                <span />
                <span />
              </p>
            </Loader>
          )}
          <Button
            btnAnimation={btnAnimation === "ok"}
            soundPlayed={soundPlayed}
            onAnimationEnd={() => {
              setBtnAnimation(false);
              setSoundPlayed(false);
            }}
            onClick={() => {
              setBtnAnimation("ok");
              setSoundPlayed(true);
              confirm();
              setTimeout(() => {
                handleAbove("history");
                handleAboveAnimation(true);
              }, 167);
            }}
          >
            OK
          </Button>
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
